import React from "react";
import classnames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";

import { videoDetailDates } from "../../../../helpers/convertDate";

import AddToListDownLoad from "./AddToListDownLoad";
import PlayerToolbarWrapper from "./styles/PlayerToolbar.style";

function Toolbar(props) {
  const { video, addFavorite, location, auth, history, isMobile } = props;
  const { originalPublishingDate, signedDate } = video;
  let insider =
    auth.loggedIn && auth.user.roles.includes("ROLE_INSIDER") ? true : false;

  return (
    <PlayerToolbarWrapper>
      {!isMobile && (
        <div className={classnames("date--location", { insider: insider })}>
          <div className="fields">
            <span className="label">Date Posted:</span>
            <span className="value">
              {originalPublishingDate
                ? videoDetailDates(originalPublishingDate)
                : signedDate
                ? videoDetailDates(signedDate)
                : "N/A"}
            </span>
          </div>
          <div className="fields">
            <span className="label">Location:</span>
            <Tooltip
              title={video.location || "Unavailable"}
              disableHoverListener={Boolean(video.location)}
              placement="bottom"
              arrow
            >
              <span className="value location">
                {video.location || "Unavailable"}
              </span>
            </Tooltip>
          </div>
        </div>
      )}
      <div className="cta">
        <AddToListDownLoad
          video={video}
          addFavorite={addFavorite}
          auth={auth}
          location={location}
          history={history}
        />
      </div>
    </PlayerToolbarWrapper>
  );
}

export default Toolbar;
